export class CommonDialogNames {
    public static readonly StandardOkDialog_NAME: string = "StandardOkDialog"; // NOPMD
    public static readonly StandardDoubleOkDialog_NAME: string = "StandardDoubleOkDialog"; // NOPMD
    public static readonly StandardYesNoDialog_NAME: string = "StandardYesNoDialog"; // NOPMD
    public static readonly ReconnectDialog_NAME: string = "ReconnectDialog"; // NOPMD
    public static readonly RegisterDialog_NAME: string = "RegisterDialog"; // NOPMD

    // korea-dialog for missing id verification (via Siren24)
    public static readonly KoreaMissingIdCheckDialog_NAME: string = "KoreaMissingIdCheck";
}

